import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b55ed69a")

_pushScopeId("data-v-b55ed69a")
const _hoisted_1 = { class: "ensure_main" }
const _hoisted_2 = { class: "ensure_body" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h3", null, "保障服务说明", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("i", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", {
        class: "ensure_title",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toView('268vServiceDesc')))
      }, [
        _createVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.getData('268vServiceDesc', 'name')), 1),
          _hoisted_4
        ])
      ]),
      (_ctx.getData('paidWarrantyDesc', 'name'))
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "ensure_title ensure_margin",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toView('paidWarrantyDesc')))
          }, [
            _createVNode("p", null, [
              _createTextVNode(_toDisplayString(_ctx.getData('paidWarrantyDesc', 'name')), 1),
              _hoisted_5
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})